/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

iaw.apps = iaw.apps || {};
iaw.apps.phxs = {
    /**
     * Asynchronously retrieves the basic host JSON and passes it to the callback
     *
	 * @param mode		string key for host data mode
     */
	init: function(receivedHostData, mode) {
		function parseHostData(supportData, callbackMethod) {
			if (!supportData) return;

			var hostData = null;

			try {
				hostData = iaw.apps.phxs.buildHostData(mode, supportData);
				for (var key in hostData) {
					hostData[key] = iaw.json.fnftDataReceiver(key, hostData[key]);
				}

			}
			catch (err) {
				iaw.log.exception('Host JSON parse error: ' + err.message);
			}
			// check if our parse went ok
			callbackMethod(hostData);
		}

		function fetchFromProduct(callback) {
			iaw.cepUtil.evalExtendScript('CCXWelcomeXSHost_PHXS.getInitJSON("' + mode + '")', function(supportDataJSON) {
				var supportData = JSON.parse(supportDataJSON);
				iaw.localstorage.setGlobalItem('phxsHostData', supportData);
				callback(supportData);
			});
		}

		var phxsHostData = iaw.localstorage.getGlobalItem('phxsHostData');

		if (!phxsHostData) {
			fetchFromProduct(function(data) {
				parseHostData(data, receivedHostData);
			});
		}
		else {
			parseHostData(phxsHostData, receivedHostData);
			riotctrl.once('update-details-retro', function() {
				fetchFromProduct(function(newHostData) {
					// Quietly update the host data cache if
					// these things change.
					['secondsLeftInTrial', 'appStartClockTime'].forEach(function(item) {
						delete newHostData.envInfo[item];
						delete phxsHostData.envInfo[item];
					});

					// These items have a huge impact even though they change rarely.
					// Lets reload the app right now (don't wait for the next launch)
					['accountType', 'firstName', 'lastName', 'countryCode', 'locale', 'subscription', 'userGUID'].find(function(item) {
						if (newHostData.envInfo[item] !== phxsHostData.envInfo[item]) {
							window.location.reload();
							return true;
						}
					});

					if (JSON.stringify(newHostData) !== JSON.stringify(phxsHostData)) {
						// Lets reload the sidebar.
						parseHostData(newHostData, function(data) {
							var hostData = iaw.store.get('host');
							for (var key in data) {
								hostData[key] = data[key];
							}
							iaw.store.set('host', hostData);

							riotctrl.trigger('reload-sidebar');
						});
					}
				});
			});
		}

	},

    /**
     * Asynchronously retrieves the host preset JSON and passes it to the callback
     *
	 * @param mode		string key for host data mode
     */
	initPresets: function(receivedHostData, mode) {

		var hostID = iaw.cepUtil.applicationID;

		iaw.cepUtil.evalExtendScript('CCXWelcomeXSHost_'+hostID+'.getPresetJSON("'+mode+'")', function(supportDataJSON) {

			if (!supportDataJSON) return;

			var presets;

			try {
				presets = iaw.apps.phxs.buildHostPreset(mode, supportDataJSON);
				for (var key in presets) {
					presets[key] = iaw.json.fnftDataReceiver(key, presets[key]);
				}
			}
			catch (err) {
				iaw.log.exception('Host JSON parse error: ' + err.message);
			}

			// Update the time to be in the correct time zone as the machine
			var tzOffset = new Date().getTimezoneOffset() * 60 * 1000;
			presets.forEach(function(preset) {
				preset.lastUsedTime += tzOffset;
			});

			// check if our parse went ok
			receivedHostData(presets);
		});
	},

	/**
	 * Builds the host json, minus the preset info
	 *
	 * @param mode		string key for host data mode
	 * @return Host data object
	 */
	buildHostData : function(mode, supportData) {
		var phsxEnvInfo = supportData.envInfo;

		var userData = {
			hostID                : 'PHXS',
			appVersion            : phsxEnvInfo.appVersion,
			platform              : phsxEnvInfo.platform,
			displayMode           : phsxEnvInfo.displayMode,
			sessionGUID           : phsxEnvInfo.sessionGUID,
			userTrackingEnabled   : phsxEnvInfo.userTrackingEnabled,
			language              : phsxEnvInfo.locale,
			countryCode           : phsxEnvInfo.countryCode,
			adobeGUID             : phsxEnvInfo.userGUID,
			accountStatus         : phsxEnvInfo.subscription,
			accountType           : phsxEnvInfo.accountType
		};

		// save locale for getPresetArray
		this.locale = phsxEnvInfo.locale;

		// add presets for 'file new from template' mode
		if (mode && mode === 'fnft') {
			userData.fnftSettings = this.getFNFTData(supportData);
			userData.displayMode = mode;

			// Save this for later because it is also needed for preset JSON building
			iaw.store.set('phxsFNFTConfigInfo', supportData.fnftConfigInfo);
		}
		else {
			userData.firstName = phsxEnvInfo.firstName;
			userData.lastName = phsxEnvInfo.lastName;
			userData.tabs = this.getFileTabs(supportData);
			userData.appStartClockTime = phsxEnvInfo.appStartClockTime;
			userData.secondsLeftInTrial = phsxEnvInfo.secondsLeftInTrial;
			userData.dontShowAgain = phsxEnvInfo.startDSA;
			userData.buttonInfo = phsxEnvInfo.buttonInfo;
			userData.fnftEnabled =  phsxEnvInfo.fnftEnabled;
		}
		return userData;
	},

	/**
	 * Builds the presets (and recently used templates) for the host application
	 *
	 * @param mode		string key for host data mode
	 * @return Preset data
	 */
	buildHostPreset : function(mode, supportDataJSON) {

		var presets = [];

		if (mode && mode === 'fnft') {

			var supportData = JSON.parse(supportDataJSON);

			supportData.fnftConfigInfo = iaw.store.get('phxsFNFTConfigInfo');

			presets = this.getPresetArray(supportData);
		}

		return presets;
	},

	/**
	 * Gets the File New From Template settings from the preferences.
	 *
	 * @return JSON representation of the data.
	 */
	getFNFTData : function(supportData) {
		var configInfo = supportData.fnftConfigInfo,
			envInfo = supportData.envInfo,
			pixelAspectRatios;

		// Convert pixel ratios list into a slightly more view-friendly format
		pixelAspectRatios = supportData.pixelScaleFactorList &&
			supportData.pixelScaleFactorList.pixelScaleFactorList &&
			supportData.pixelScaleFactorList.pixelScaleFactorList.map(function(item, index) {
				return {
					label: item.name + (index === 0 ? '' : ' (' + iaw.util.roundDecimal(item.value, 2) + ')'),
					value: item.value
				};
			}) || [];

		var settings = {
			// min/max size bounds in pixels for a document
			docSizeBounds: [300000, 300000],

			// units to be displayed in the size(w/h) dropdown
			units: [
				'pixelsUnit',
				'inchesUnit',
				'centimetersUnit',
				'millimetersUnit',
				'pointsUnit',
				'picasUnit'
			],

			// units to be displayed in the resolution dropdown
			resolutionUnits: [
				'inchesUnit',
				'centimetersUnit'
			],

			// color modes to be displayed in the color mode/bit depth dropdown
			// the mode parameter acts as both a setting and as a translation keystring
			colorModes: [
				{ mode: 'bitmap', values: [1] },
				{ mode: 'grayscale', values: [8, 16, 32] },
				{ mode: 'RGB', values: [8, 16, 32] },
				{ mode: 'CMYK', values: [8, 16] },
				{ mode: 'Lab', values: [8, 16] }
			],

			// background modes to be set in the background dropdown
			// value acts both a setting and as a translation keystring
			backgroundValues: [
				'white',
				'black',
				'background',
				'transparent',
				'custom'
			],

			// current background color of photoshop
			backgroundColor: configInfo.backgroundColor,

			// conversion constant from points to picas from preferences
			pointsPerInch: configInfo.pointsPerInch,

			// default document name
			defaultDocumentName: configInfo.defaultNewDocName || null,

			// List of valid color profiles
			colorProfileLists: envInfo.colorProfileLists,

			// Information about current color settings, including workingProfile and policy
			colorSettings: configInfo.colorSettings || {},

			// Information about the user locale decimal 
			userLocaleDecimal: configInfo.userLocaleDecimal || '.',

			// starting attributes
			defaultPresetSettings: configInfo.startingPreset || null,

			// list of valid pixel aspect ratios
			pixelAspectRatios: pixelAspectRatios,

			// can we use events to create docs from FNFT?
			psSupportsDocCreationViaCEPEvents: configInfo.supportsDocCreationViaCEPEvents || false

		};

		return settings;
	},

	/**
	 * Build out the list of tabs.
	 *
	 * @return an array containing the list of tab structures.
	 */
	getFileTabs : function(supportData) {

		var tabsArray   = [];
		var recentFiles = {
			'type' : 'recentfile',
			'label' : 'listview_recentfiles_tab_label',
			'listViewEnabled' : 'true',
			'thumbnailViewEnabled' : 'true',
			'list' : supportData.recentFiles.list
		};
		tabsArray.push( recentFiles );

		return tabsArray;
	},

	/**
	 * Build the list of preset file types.
	 *
	 * @return array object containing the list of presets.
	 */
	getPresetArray : function(supportData) {

		var presetArray = [];

		// feed in the MRU presets
		var mruArray = this.getRecentlyUsedPresets(supportData);

		// now feed in the MRU templates
		/*
		mruArray = [
			{
				'elementRef': 'cloud-asset://cc-api-storage.adobe.io/assets/adobe-libraries/1d898ff1-7e41-44f0-8fe1-7b429bbd34fd;node=b943f298-127a-4362-8d1f-733a70f4c1fc',
				'lastUsedTime': 1460161754340
			},
			{
				'elementRef': 'cloud-asset://cc-api-storage.adobe.io/assets/adobe-libraries/1d898ff1-7e41-44f0-8fe1-7b429bbd34fd;node=fea9a462-48f2-41aa-93ec-8d33b05fe225',
				'lastUsedTime': 1460161700176
			},
			{
				'elementRef': 'cloud-asset://cc-api-storage.adobe.io/assets/adobe-libraries/1d898ff1-7e41-44f0-8fe1-7b429bbd34fd;node=6fc72153-fff0-4e04-868f-8eae89444d7f',
				'lastUsedTime': 1460161706897
			}
		];
		*/

		var mruTemplates = supportData.mruTemplates.recentlyUsedTemplates;

		if (mruTemplates) {

			// Fixup MRU templates
			for (var mruIndex = 0; mruIndex < mruTemplates.length; ++mruIndex) {
				mruTemplates[mruIndex].template_category = 'needslookup';	// eslint-disable-line camelcase
			}

			// Combine MRU templates and MRU presets
			mruArray = mruArray.concat(mruTemplates);
		}

		// Sort MRU based on timestamp, newest first
		mruArray.sort(function(a, b) {
			if (a.lastUsedTime > b.lastUsedTime) {
				return -1;
			}
			else if (a.lastUsedTime < b.lastUsedTime) {
				return 1;
			}
			return 0;
		});

		// Add all the MRU to the main list
		presetArray = presetArray.concat(mruArray);

		var psPresets = supportData.presets;

		// parse out the presets into the format we need
		if (psPresets.sections) {

			// This maps Photoshop preset sections to the relevant ccx template categories.
			// It is opt-in order of items in the 'sections' arrays is important.
			// MRU are a special case;  they aren't in psPresets but get added above instead,
			// and the clipboard gets artificially forced in front of them.
			//
			// Yes, the loops are quadratic, but the number of sections is small, and unmappped
			// sections get skipped, it enables mapping a single section to multiple categories
			// if desired, and it ensures that the extension controls the ordering rather than
			// being dependent on the order of sections coming from Photoshop.

			var tmpCatToSec;
			
			if (this.locale == 'ja_JP') {
				//Japan has a different print order. PS-4795
				tmpCatToSec = [
					{ category : 'recent',	sections : ['clipboard'/*, 'mru'*/] },
					{ category : 'saved',   sections : ['user'] },
					{ category : 'photo',	sections : ['default', 'photo'] },
					{ category : 'print',	sections : ['europaper', 'uspaper'] },
					{ category : 'mobile',	sections : ['mobile', 'iconography'] },
					{ category : 'film',	sections : ['video'] },
					{ category : 'web',		sections : ['web'] },
					{ category : 'art',		sections : ['artillustration'] }
				];
			}
			else {
				tmpCatToSec = [
					{ category : 'recent',	sections : ['clipboard'/*, 'mru'*/] },
					{ category : 'saved',   sections : ['user'] },
					{ category : 'photo',	sections : ['default', 'photo'] },
					{ category : 'print',	sections : ['uspaper', 'europaper'] },
					{ category : 'mobile',	sections : ['mobile', 'iconography'] },
					{ category : 'film',	sections : ['video'] },
					{ category : 'web',		sections : ['web'] },
					{ category : 'art',		sections : ['artillustration'] }
				];
			}

			// Loop through each category, and each section in each category
			for (var catIndex = 0; catIndex < tmpCatToSec.length; ++catIndex) {

				for (var sectIndex = 0; sectIndex < tmpCatToSec[catIndex].sections.length; ++sectIndex) {

					// Find the current section in the psPresets array
					var section = tmpCatToSec[catIndex].sections[sectIndex];

					for (var index = 0; index < psPresets.sections.length; ++index) {
						if (psPresets.sections[index].section === section && psPresets.sections[index].presets) {

							// Add the presets from the found section into the ccx preset array
							this.addPsPresetListToCCXPresetEntryList(psPresets.sections[index].presets, tmpCatToSec[catIndex].category, supportData.fnftConfigInfo, presetArray);
						}
					}
				}
			}
		}

		return presetArray;
	},

	/**
	 * Get the list of most recently used (MRU) PS Presets
	 *
	 * @return An array containing the list of MRU presets.
	 */
	getRecentlyUsedPresets : function(supportData) {

		var mruArray = [];

		if (supportData.mruPresets.mru) {
			this.addPsPresetListToCCXPresetEntryList(supportData.mruPresets.mru, 'recent', supportData.fnftConfigInfo, mruArray);
		}
		return mruArray;
	},



	/**
	 * Get a preset thumbnail based on category and title.
	 *
	 * @return The filename for the thumbnail
	 */
	thumbnailForPreset : function(category, title) {

		switch (category) {
			case 'photo':
				return 'SP_PresetPhotoDoc.png';

			case 'europaper':
			case 'uspaper':
				return 'SP_PrintDoc.png';

			case 'mobile':
				// Per XD we are dropping per-device icons for initial release (out of scope).
				// Note that this code is not very localization friendly. 'iPad' and 'Surface'
				// probably don't get localized, but 'Mobile Design' will, so we can't match
				// against it with an unlocalized string.
			/*	if (title.indexOf('iPad') >= 0) {
					return 'SP_PresetTabletApp.png';
				}
				else if (title.indexOf('Surface') >= 0) {
					return 'SP_PresetSurfacePro.png';
				}
				else if (title.indexOf('Mobile Design') >= 0) {
					return 'SP_PresetMobileAppDoc.png';
				}*/
				return 'SP_PresetMobilePhoneDoc.png';

			case 'iconography':
				return 'SP_PresetIconographyDoc.png';

			case 'video':
				return 'SP_PresetFilmVideo.png';

			case 'web':
				return 'SP_PresetWebDoc.png';

			case 'artillustration':
				return 'SP_PresetArt.png';

			case 'clipboard':
				return 'SP_PresetClipboard.png';

			case 'default':
				return 'CCX_Start_DefaultThumb_Ps_Ai_Id.png';

			case 'last':
			default:
				// Return custom below
				break;
		}

		return 'SP_PresetCustom.png';
	},

	/**
	 * Converts a Photoshop preset (from the JSON) into a ccx preset entry
	 * for use in the core extension.
	 *
	 * @return A ccx appropriate preset
	 */
	convertPsPresetToCCXPresetEntry : function(psPreset, category, configInfo) {

		// skip the separator presets
		if (psPreset.name === 'separator') {
			return undefined;
		}

		// Start with the psPreset itself; all unknown data needs to be
		// round-tripped back to Photoshop.
		var presetEntry = psPreset;

		// Add fields that are needed for ccx
		presetEntry.isPreset = true;
		presetEntry.id = '';
		presetEntry.title = presetEntry.name;
		presetEntry.thumbnail_url = '';				// eslint-disable-line camelcase
		presetEntry.mime_type = 'image/photoshop';	// eslint-disable-line camelcase
		presetEntry.price_prompt = '';				// eslint-disable-line camelcase
		presetEntry.template_category = 'error';	// eslint-disable-line camelcase
		presetEntry.previews = [];

		// adjust resolution to value
		if (presetEntry.resolution === 'screen') {
			presetEntry.resolution = configInfo.screenPresetResolution.value;
			presetEntry.resolutionUnits = configInfo.screenPresetResolution.units;
		}
		else if (presetEntry.resolution === 'print') {
			presetEntry.resolution = configInfo.printPresetResolution.value;
			presetEntry.resolutionUnits = configInfo.printPresetResolution.units;
		}

		// set category
		presetEntry.template_category = category;	// eslint-disable-line camelcase

		// Set thumbnail
		presetEntry.thumbnail_url = this.thumbnailForPreset(presetEntry.group, presetEntry.title);	// eslint-disable-line camelcase

		return presetEntry;
	},

	/**
	 * Converts a list of Photoshop preset (from the JSON) into ccx preset entries
	 * for use in the core extension and adds them to the provided array.
	 */
	addPsPresetListToCCXPresetEntryList : function(psPresets, category, configInfo, ccxPresetArray) {

		for (var presetIndex = 0; presetIndex < psPresets.length; ++presetIndex) {

			// skip the separator presets
			if (psPresets[presetIndex].name !== 'separator') {

				var presetEntry = this.convertPsPresetToCCXPresetEntry(psPresets[presetIndex], category, configInfo);

				if (presetEntry) {
					// add to the preset array
					if (presetEntry.group !== 'clipboard') {
						ccxPresetArray.push(presetEntry);
					}
					else { // clipboard always first
						ccxPresetArray.unshift(presetEntry);
					}
				}
			}
		}
	},

	/**
	 * Launch native photoshop color picker and return a promise of a new color object.
	 * May resolve with null if dialog is canceled
	 *
	 * @param {object} color to initialize picker with
	 * @return {Promise.<?object>}
	 */
	promptForCustomColor : function(color) {
		var _color = color,
			dialogContext = iaw.i18n.getLocalizedString('newdoc_color-picker_context'),
			colorJSON,
			serializedParams;

		// failsafe in case no initial color is available
		if (!(color instanceof Object)) {
			_color = { 'red': 255, 'grain': 255, 'blue': 255, 'type': 'RGBColor' };
		}

		// prep for sending as string param to extendscript eval
		colorJSON = JSON.stringify(_color).replace(/"/g, '\\"');
		serializedParams = '"'+ colorJSON + '", "' + dialogContext + '"';

		return new Promise(function(resolve, reject) {
			try {
				iaw.cepUtil.evalExtendScript('CCXWelcomeXSHost_PHXS.openColorPicker(' + serializedParams + ')', function(resultJSON) {
					if (resultJSON) {
						try {
							var result = JSON.parse(resultJSON);

							resolve(result);
						}
						catch (e) {
							reject(new Error('Failed to parse result from openColorPicker', e));
						}
					}

					// this might just mean the dialog was canceled?
					resolve(null);
				});
			}
			catch (e) {
				reject(new Error('Failed to get color via color picker', e));
			}
		});
	},

	/**
	 * Use photoshop extendscript utility to convert any photoshop color object to RGB.
	 * Returns a promise of a new color object
	 *
	 * @param {object} color
	 * @return {Promise.<object>} RGBColor type color
	 */
	convertColorToRGB : function(color) {
		if (!color) {
			return new Promise(function(resolve, reject) {
				resolve({ 'red': 255, 'grain': 255, 'blue': 255, 'type': 'RGBColor' });
			});
		}

		var colorJSON = JSON.stringify(color).replace(/"/g, '\\"');

		return new Promise(function(resolve, reject) {
			try {
				iaw.cepUtil.evalExtendScript('CCXWelcomeXSHost_PHXS.convertColorToRGB("'+ colorJSON +'")', function(resultJSON) {
					if (resultJSON) {
						try {
							var result = JSON.parse(resultJSON);
							resolve(result);
						}
						catch (e) {
							reject(new Error('Failed to parse result from convertColorToRGB', e));
						}
					}
					reject(new Error('convertColorToRGB Failed to convert color, empty result'));
				});
			}
			catch (e) {
				reject(new Error('convertColorToRGB Failed to convert color', e));
			}
		});
	},

	/**
	 * Convert a RGBColor object from Photoshop into CSS-compatible rgb format
	 *
	 * @param {!object} obj
	 * @return {string} of format "rgb(100, 100, 100)"
	 */
	rgbFormat: function(obj) {
		return 'rgb(' +
			Math.round(obj.red) + ', ' +
			Math.round((obj.grain !== undefined ? obj.grain : obj.green)) + ', ' +
			Math.round(obj.blue) + ')';
	}

};
